import { useSeniorityTierOptions } from "lib/hooks/api/contacts/useSeniorityTierOptions";
import LabelledMultiSelectFilter from "./LabelledMultiSelectFilter";

export type SeniorityTierFilterProps = {
  value: string[];
  onChange: (value: string[]) => void;
};

/**
 * Multi-select for the unified seniority tier. Self-contained: fetches its own
 * backend-served options (React Query dedupes across instances) and emits the selected
 * tier keys. Rendered as a labelled select so it matches the buyer selects in the sidebar.
 */
function SeniorityTierFilter({ value, onChange }: SeniorityTierFilterProps) {
  const { data } = useSeniorityTierOptions();
  const options = (data ?? []).map((o) => ({ label: o.label, value: String(o.value) }));

  return (
    <LabelledMultiSelectFilter
      label="Seniority"
      placeholder="Select seniority"
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}

export default SeniorityTierFilter;
